import script from "./ApprovedLimit.vue?vue&type=script&setup=true&lang=js"
export * from "./ApprovedLimit.vue?vue&type=script&setup=true&lang=js"

import "./ApprovedLimit.vue?vue&type=style&index=0&id=2946c24a&lang=css"

const __exports__ = script;

export default __exports__